import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const DrawingEditorToolEraseV2Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 20 20"
        className="Icon drawing-editor-tool-erase-v-2"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.67}
            d="M15 10.832 9.165 5m8.333 12.5H6.666m2.448-.78 7.223-7.225c.99-.99 1.485-1.485 1.67-2.056a2.5 2.5 0 0 0 0-1.545c-.185-.57-.68-1.066-1.67-2.056l-.176-.176c-.99-.99-1.485-1.485-2.056-1.67a2.5 2.5 0 0 0-1.545 0c-.57.185-1.066.68-2.056 1.67l-6.843 6.843c-.99.99-1.485 1.485-1.67 2.056a2.5 2.5 0 0 0 0 1.545c.185.57.68 1.066 1.67 2.056l.557.557c.288.288.432.433.6.536q.226.136.482.2c.192.045.396.045.804.045h1.124c.408 0 .611 0 .803-.046q.257-.061.482-.2c.168-.102.312-.247.6-.535Z"
        />
    </svg>
);
const Memo = memo(DrawingEditorToolEraseV2Icon);
export default Memo;
